import { motion } from 'framer-motion'
import { PropsWithChildren } from 'react'

import styles from './OverlayLayout.module.scss'

export const OverlayLayout = ({ children }: PropsWithChildren) => {
  return (
    <motion.div
      className={styles.backdrop}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.border}>{children}</div>
    </motion.div>
  )
}
